<script>
export default {
  props: {
    details: {
      type: Object,
      default: () => {}
    },
    NationCode: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    getIsActive(item) {
      return item.NationDistCode === this.NationCode || item.Code === this.NationCode
    }
  }
}
</script>

<template>
<div class="hs-nation-item" :id="`letter${details && details.Label}`">
  <div class="title" v-if="details && details.Label">{{ details.Label }}</div>
  <div class="list" v-if="details && details.NationList && details.NationList.length > 0">
    <div
        class="item"
        v-for="(item, index) in details.NationList"
        :key="index"
        :class="{active: getIsActive(item)}"
        @click="$emit('select', item)"
    >
      <div class="label" v-if="type === 'mobileCountryCode'">
        {{item.Code}} {{ getMobileCountryName(item)}}
      </div>
      <div class="label" v-else>
        {{ getNationName(item) || getMobileCountryName(item)}}
        <span v-if="item.Code">{{item.Code}}</span>
      </div>
      <div class="logo"></div>
    </div>
  </div>
</div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/variable'
@import '~common/stylus/base'
.hs-nation-item{
  width: 100%;
  word-break: break-word;
  >.title{
    @extend .flex-start;
    @extend .hs-font-caption-1;
    width: 100%;
    padding: 8px 12px;
    color: $color_black_100;
  }
  >.list{
    width: 100%;
    margin-bottom: 12px;
    >.item{
      @extend .flex-start;
      width: 100%;
      min-height: 56px;
      position: relative;
      &:after{
        position: absolute;
        left: 12px;
        bottom: 0;
        width: calc(100% - 12px);
        height: 0;
        content: ' ';
        border-bottom: 0.5px solid $color_black_30;
      }
      &.active{
        >.label{
          color: $color_theme_300;
        }
        >.logo{
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          margin: auto 12px;
          background-image: url('@/assets/image/base/check-box/icons_16pt_right.png');
          background-size: 100% 100%;
        }
      }
      >.label{
        @extend .flex-start;
        @extend .hs-font-body;
        width: 100%;
        padding: 8px 12px;
        >span{
          color: $color_black_100;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
